import React from 'react'

import styled, { css } from 'styled-components'

const FilterContainer = styled.div`
  display: flex;
  width: fit-content;

  ${({ theme }) => {
    switch (theme.template) {
      case 'template-4':
        return css`
          margin-top: auto;

          @media ${theme.mediaQueries.mobile} {
            width: 100%;
            grid-column: 1 / span 2;
            justify-content: space-between;
            grid-row: 2;
            margin-top: 2rem;
          }
        `
      default:
        return css`
          background-color: ${theme.palette.neutral['grey-f6f7fa']};
          border-radius: 1.25rem;
          width: fit-content;
        `
    }
  }};
`

const FilterButton = styled.button<{ active?: boolean }>`
  border: none;
  cursor: pointer;

  ${({ theme, active }) => {
    switch (theme.template) {
      case 'template-4':
        return css`
          padding: 0.125rem 0.75rem;
          color: ${active
            ? theme.palette.neutral.white
            : theme.palette.brand.darkPurple};
          background-color: ${active
            ? theme.palette.brand.newPurple
            : theme.palette.brand.lightPurple};
          font-size: 0.875rem;
          border-radius: 0.25rem;
          line-height: 1.5rem;
          font-weight: 500;
          text-transform: uppercase;

          &:not(:last-child) {
            margin-right: 0.5rem;
          }
        `
      default:
        return css`
          background-color: ${active
            ? theme.palette.teal['100']
            : 'transparent'};
          border-radius: 1.25rem;
          padding: 0.25rem 1rem;
          font-size: 1rem;
        `
    }
  }}
`

export interface TabFilterProps<
  Opts extends Readonly<
    {
      value: string
      label: string
    }[]
  >
> {
  readonly options: Opts
  readonly defaultValue?: Opts[number]['value']
  onSelect(item: Opts[number]['value']): void
  value?: Opts[number]['value'] | null
}

export const TabFilter = <
  Opts extends Readonly<
    {
      value: string
      label: string
    }[]
  >
>({
  options,
  value,
  defaultValue,
  onSelect,
}: TabFilterProps<Opts>): JSX.Element => (
  <FilterContainer>
    {options.map(opt => {
      const onClick = () => onSelect(opt.value)
      const active = value ? value === opt.value : defaultValue === opt.value

      return (
        <FilterButton
          key={opt.value}
          active={active}
          onClick={onClick}
          type="button"
        >
          {opt.label}
        </FilterButton>
      )
    })}
  </FilterContainer>
)
